import {IBaseSchema} from '../base.schema';
import {
    PMP_PAYMENT_TYPE_MEDIATION,
    PMP_PAYMENT_TYPE_PARTICIPANT_EVAL,
    PMP_PAYMENT_TYPE_POST_SESSION,
    PMP_PAYMENT_TYPE_REFERRAL,
    PMP_PAYMENT_TYPE_SCHEDULING,
    PMP_PAYMENT_TYPE_SCREENING,
    PMP_PAYMENT_TYPE_TELEPHONE_INTERVIEW,
} from './activity';
import {ICenter} from './center';

export type PmpInvoiceStatus = 'Pending' | 'Submitted' | 'Approved';

export interface IPmpInvoice extends IBaseSchema {
    center: ICenter;
    start: Date;
    end: Date;
    invoiceId: string;
    status: PmpInvoiceStatus;
    pmpPayments: IPmpPayments;
}

export type IPmpInvoiceCreate = Omit<IPmpInvoice, '_id'>;

export interface IPmpInvoiceTable extends Pick<IPmpInvoice, 'center'> {
    _id: string;
}

export interface IPmpPaymentSearch {
    start: Date;
    end: Date;
}

// export interface PmpPaymentActivityData {
//     activityData: IActivityData;
//     pmpPayments: IPmpPayment;
// }

export interface IPmpPaymentActivityData {
    _id: string;
    date: Date;
    pmpCaseNumber: string;
    hours: number;
    activityId: string;
    title: string;
    cp?: string;
    ncp?: string;
    amount?: number;
    completedInterviews?: boolean;
}

export interface IPmpPayments {
    [PMP_PAYMENT_TYPE_REFERRAL]?: IPmpPaymentActivityData[];
    [PMP_PAYMENT_TYPE_SCREENING]?: IPmpPaymentActivityData[];
    [PMP_PAYMENT_TYPE_SCHEDULING]?: IPmpPaymentActivityData[];
    [PMP_PAYMENT_TYPE_MEDIATION]?: IPmpPaymentActivityData[];
    [PMP_PAYMENT_TYPE_PARTICIPANT_EVAL]?: IPmpPaymentActivityData[];
    [PMP_PAYMENT_TYPE_TELEPHONE_INTERVIEW]?: IPmpPaymentActivityData[];
    [PMP_PAYMENT_TYPE_POST_SESSION]?: IPmpPaymentActivityData[];
}

export const RATE_REFERRAL = 25;
export const RATE_SCREENING_ASSESSMENT = 50;
export const RATE_SCHEDULING_AND_PRE_SESSION = 50;
export const RATE_MEDIATION = 150;
export const RATE_PARTICIPANT_EVAL = 25;
export const RATE_TELEPHONE_INTERVIEW = 25;
export const RATE_POST_SESSION = 25;

export const TITLE_REFERRAL = 'Referral';
export const TITLE_SCREENING = 'Screening/Assessment';
export const TITLE_SCHEDULING = 'Scheduling & Pre-Session Preparation';
export const TITLE_MEDIATION = 'Mediation & Session Debrief';
export const TITLE_MEDIATION_MOU = 'Mediation & Session Debrief (MOU write-up)';
export const TITLE_PARTICIPANT_EVAL = 'Participant Evaluation Follow-up with Parties';
export const TITLE_TELEPHONE_INTERVIEW = 'Telephone Interview Follow-up with Parties';
export const TITLE_POST_SESSION = 'Post Session Follow-up with Mediator(s)';
